package com.dotdrives.web.pages

import com.dotdrives.web.shell.NavItem
import com.dotdrives.web.ui.DotAction
import com.dotdrives.web.ui.DotEmptyState
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.span
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

external interface ModulePlaceholderProps : Props {
    var module: NavItem
    var onNavigate: (NavItem) -> Unit
}

val ModulePlaceholderPage = FC<ModulePlaceholderProps> { props ->
    div {
        className = ClassName("module-placeholder")
        DotEmptyState {
            emoji = props.module.emoji()
            title = props.module.placeholderTitle()
            body = "${props.module.label} is part of the new Dot Drives portal. This workspace is ready for its module."
            primaryAction = if (props.module == NavItem.Dashboard) {
                DotAction("View Next Steps") { props.onNavigate(NavItem.NextSteps) }
            } else {
                DotAction("Back to Dashboard") { props.onNavigate(NavItem.Dashboard) }
            }
        }
    }
}

external interface OnboardingPlaceholderProps : Props {
    var onSignOut: () -> Unit
}

val OnboardingPlaceholderPage = FC<OnboardingPlaceholderProps> { props ->
    div {
        className = ClassName("onboarding-placeholder")
        DotEmptyState {
            emoji = "↗"
            title = "Let's set up your organization"
            body = "Your account is ready. The guided setup arrives in the next build."
            primaryAction = DotAction("Sign out", props.onSignOut)
        }
    }
}

val BrandSplash = FC<Props> {
    div {
        className = ClassName("brand-splash")
        div {
            className = ClassName("brand-splash-mark")
            ariaHidden = true
            +"•••"
        }
        h1 {
            className = ClassName("brand-splash-title dot-heading")
            +"dot drives"
        }
        p {
            className = ClassName("brand-splash-copy dot-meta")
            +"FUNDRAISING THAT MOVES"
        }
    }
}

typealias GivingPortalProps = com.dotdrives.web.DonorCompositionProps
val GivingPortalPage = com.dotdrives.web.DonorComposition

private fun NavItem.emoji(): String = when (this) {
    NavItem.Dashboard -> "⌂"
    NavItem.NextSteps -> "✓"
    NavItem.Drives -> "◇"
    NavItem.Givers -> "👥"
    NavItem.Donations -> "♥"
    NavItem.Forms -> "📝"
    NavItem.Updates -> "↗"
    NavItem.Reports -> "▥"
    NavItem.Settings -> "⚙"
}

private fun NavItem.placeholderTitle(): String = when (this) {
    NavItem.Dashboard -> "Your dashboard starts here"
    NavItem.NextSteps -> "Next Steps"
    NavItem.Drives -> "Drives"
    NavItem.Givers -> "Givers"
    NavItem.Donations -> "Donations"
    NavItem.Forms -> "Giving forms"
    NavItem.Updates -> "Updates"
    NavItem.Reports -> "Reports"
    NavItem.Settings -> "Settings"
}
